import {Controller} from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab']

  connect() {
    this.tabTargets.forEach(tab => {
      tab.addEventListener("click", this.handleClick.bind(this));
    });

    // Display tab if only one is available
    if (this.tabTargets.length === 1) {
      let target = this.tabTargets[0]
      target.classList.add('active')
      document.querySelector(target.dataset.paymentTabsSelector).classList.add('show')
    }
  }

  disconnect() {
    this.tabTargets.forEach(tab => {
      tab.removeEventListener("click", this.handleClick.bind(this));
    });
  }

  handleClick(event) {
    event.preventDefault()

    if (event.currentTarget.classList.contains('active')) {
      // Close tab
      event.currentTarget.classList.remove('active')
      document.querySelector(event.currentTarget.dataset.paymentTabsSelector).classList.remove('show')
    } else {
      // Close open tab
      this.tabTargets.forEach(target => {
        if (target.classList.contains('active')) {
          target.classList.remove('active')
          document.querySelector(target.dataset.paymentTabsSelector).classList.remove('show')
        }
      })

      // Open clicked tab
      event.currentTarget.classList.add('active')
      document.querySelector(event.currentTarget.dataset.paymentTabsSelector).classList.add('show')
    }
  }
}